// Decodifica el payload de un JWT preservando caracteres UTF-8 (ñ, tildes, etc.).
// `atob` por sí solo devuelve un binary string Latin-1 y rompe los multibyte.
// Además normaliza base64url → base64 (los JWT usan `-`/`_` y omiten padding).

export function decodeJwtPayload<T = Record<string, unknown>>(
  token: string | null | undefined,
): T | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2 || !parts[1]) return null;
  try {
    const json = base64UrlDecodeToUtf8(parts[1]);
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}

// Un token sin `exp` o con `exp` en el pasado se considera expirado.
export function isJwtExpired(token: string | null | undefined): boolean {
  const payload = decodeJwtPayload<{ exp?: number }>(token);
  if (!payload?.exp) return true;
  return payload.exp * 1000 < Date.now();
}

function base64UrlDecodeToUtf8(input: string): string {
  const base64 = input.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder("utf-8").decode(bytes);
}
